import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Constants, SearchOperations } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { OptionsSource } from 'src/app/core/core.models';
import { Dialog, DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { RequestService } from 'src/app/core/request.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { RouteAuthorities, ValueLabel } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';
import { ProductClassification } from 'src/app/shared/product-classification/product-classification.models';
import { ProductClassificationService } from 'src/app/shared/product-classification/product-classification.service';
import { OfferedProduct } from '../../offered-products/offered-products.models';
import { OfferedProductsService } from '../../offered-products/offered-products.service';
import { AttributeSelection, ProductAttributeType, ProductCatalogue, ProductCatalogueItem } from '../product-catalogues.models';
import { ProductCatalogueItemsService } from '../product-catalogue-items.service';
import { PointOfSaleType } from '../../points-of-sale/points-of-sale.models';

@Component({
  selector: 'app-product-catalogue-items',
  templateUrl: './product-catalogue-items.component.html',
  styleUrls: ['./product-catalogue-items.component.scss']
})
export class ProductCatalogueItemsComponent extends BaseListComponent implements OnInit {
  @ViewChild('articlesGrid') articlesGrid: DxDataGridComponent;
  @Input('productCatalogue') productCatalogue: ProductCatalogue;
  @Input('pointOfSaleId') pointOfSaleId: string;
  @Input() pointOfSaleType: PointOfSaleType | string;
  @Input('showActivateButton') showActivateButton: boolean;
  @Output() selectionChangedEvent = new EventEmitter();

  url: string = `${Constants.contextPath}/product-catalogue-items`;

  deactivateItemsButtonInstance: any;

  productAttributeTypes: ValueLabel[] = [];
  showDeactivateButton: boolean = false;
  showDeleteButton: boolean = false;

  isAddByAttributeModalVisible: boolean = false;
  isAddAllModalVisible: boolean = false;
  isAddItemModalVisible: boolean = false;
  continueAfterSave: boolean = false;
  isEdit: boolean = false;
  addItemModalTitle: string = 'REBATE_POLICIES.ADD_PRODUCT';
  productAttributeType: string;
  productAttributes: ProductClassification[] = [];
  productAttributesSource: OptionsSource;
  offeredProducts: OptionsSource;
  offeredProduct: OfferedProduct;
  amountFrom: number = 0;
  discountPercentage1: number = 0;
  discountPercentage2: number = 0;
  discountPercentage3: number = 0;
  discountPrice1: number;
  discountPrice2: number;
  discountPrice3: number;
  updateProducts: boolean = false;

  productCatalogueItem: ProductCatalogueItem = new ProductCatalogueItem();
  selectedRowKeys: any[] = [];


  ngOnInit(): void {
    this.prepareLookupData();
    this.getGridData(`productCatalogue${SearchOperations.SPLIT_JOIN_OPERATOR}id${SearchOperations.EQUALITY}${this.productCatalogue.id}`);
  }

  ngOnChanges(changes) {
    if(changes && changes.productCatalogue && changes.productCatalogue.currentValue && changes.productCatalogue.previousValue && changes.productCatalogue.currentValue.status != changes.productCatalogue.previousValue.status) {
      this.refreshGrid(true)
    }
    this.offeredProducts = this.offeredProductsService.getOfferedProductsOptionsByPointOfSale(this.pointOfSaleId, `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`);
  }

  prepareLookupData() {
    this.productAttributeTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(ProductAttributeType, true), 'value', 'label', 'PRODUCTS.');
    this.offeredProducts = this.offeredProductsService.getOfferedProductsOptionsByPointOfSale(this.pointOfSaleId, `product${SearchOperations.SPLIT_JOIN_OPERATOR}active${SearchOperations.EQUALITY}${true}`);
  }

  constructor(
    private productCatalogueItemsService: ProductCatalogueItemsService,
    private productClassificationService: ProductClassificationService,
    private offeredProductsService: OfferedProductsService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService
  ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  onToolbarPreparing(event) {
    if (this.authorities.update && this.showActivateButton) {
      event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'trash',
          text: this.translateService.instant('SHARED.DELETE_ALL'),
          hint: this.translateService.instant('SHARED.DELETE_ALL'),
          showText: 'inMenu',
          onClick: this.deleteAllItems.bind(this)
        },
        locateInMenu: 'auto'
      });

      event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'trash',
          text: this.translateService.instant('PRODUCT_CATALOGUES.DELETE_SELECTED_ITEMS'),
          hint: this.translateService.instant('PRODUCT_CATALOGUES.DELETE_SELECTED_ITEMS'),
          showText: 'inMenu',
          onClick: this.deleteSelectedItems.bind(this)
        },
        locateInMenu: 'auto'
      });

      //remove default add button
      // event.toolbarOptions.items.pop();

      if (event.toolbarOptions.items.length > 0) {
        event.toolbarOptions.items.unshift({
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'add',
            hint: this.translateService.instant('REBATE_POLICIES.ADD_PRODUCT'),
            text: this.translateService.instant('REBATE_POLICIES.ADD_PRODUCT'),
            showText: 'always',
            onClick: this.openAddItemModal.bind(this),
            disabled: this.pointOfSaleId == null || !this.showActivateButton,
            stylingMode: 'outlined'
          },
          locateInMenu: 'auto'
        });
      }

      let self = this;
      if (event.toolbarOptions.items.length > 0) {
        event.toolbarOptions.items.unshift({
          widget: 'dxButton',
          options: {
            icon: 'plus',
            hint: this.translateService.instant('PRODUCT_CATALOGUES.ADD_BY_ATTRIBUTE'),
            text: this.translateService.instant('PRODUCT_CATALOGUES.ADD_BY_ATTRIBUTE'),
            showText: 'always',
            onClick: function () {
              // event.component.openAddByAttributeModal();
              self.openAddByAttributeModal();
            },
            disabled: this.pointOfSaleId == null || !this.showActivateButton,
            stylingMode: 'outlined'
          },
          location: 'after',
          locateInMenu: 'auto'

        });
      }

      if (event.toolbarOptions.items.length > 0) {
        event.toolbarOptions.items.unshift({
          widget: 'dxButton',
          options: {
            icon: 'plus',
            hint: this.translateService.instant('PRODUCT_CATALOGUES.ADD_ALL'),
            text: this.translateService.instant('PRODUCT_CATALOGUES.ADD_ALL'),
            showText: 'always',
            onClick: function () {
              self.openAddAllModal();
            },
            disabled: this.pointOfSaleId == null || !this.showActivateButton,
            stylingMode: 'outlined'
          },
          location: 'after',
          locateInMenu: 'auto'
        });
      }
    }

    if (this.authorities.update && this.productCatalogue?.id != null && this.productCatalogue?.status == 'ACTIVE') {
      event.toolbarOptions.items.unshift({
        location: 'before',
        widget: 'dxButton',
        options: {
          onInitialized: (args: any) => {
            this.deactivateItemsButtonInstance = args.component;
          },
          icon: 'notequal',
          text: this.translateService.instant('PRODUCT_CATALOGUES.DEACTIVATE_ITEMS'),
          hint: this.translateService.instant('PRODUCT_CATALOGUES.DEACTIVATE_ITEMS'),
          showText: 'inMenu',
          type: 'danger',
          onClick: this.deactivateItems.bind(this),
          stylingMode: 'outlined',
          disabled: this.selectedRowKeys == null || this.selectedRowKeys.length == 0
        },
        locateInMenu: 'auto'
      });
    }
  }

  addAll() {
    let attributeSelection: AttributeSelection = {
      pointOfSale: this.pointOfSaleId,
      productCatalogue: this.productCatalogue.id,
      amountFrom: this.amountFrom,
      discountPercentage1: this.discountPercentage1,
      discountPercentage2: this.discountPercentage2,
      discountPercentage3: this.discountPercentage3,
      updateExisting: this.updateProducts
    }
    this.productCatalogueItemsService.addItemsByPointOfSale(attributeSelection, (response) => {
      this.alertService.success('PRODUCT_CATALOGUES.ITEMS_ADDED_SUCCESSFULLY');
      this.closeAddAllModal();
      this.refreshGrid();
    });
  }

  public deleteAllItems() {
    let dialog = new Dialog('PRODUCT_CATALOGUES.DELETE_ALL_ITEMS', () => {
      this.productCatalogueItemsService.deleteAllItems(this.productCatalogue.id, (response) => {
        this.refreshGrid();
        this.alertService.success('PRODUCT_CATALOGUES.DELETE_ALL_ITEMS_SUCCESS');
      })
    });

    this.dialogService.show(dialog);
  }

  public deleteSelectedItems() {
    let dialog = new Dialog('PRODUCT_CATALOGUES.DELETE_SELECTED_ITEMS_QUESTION', () => {
      this.productCatalogueItemsService.deleteSelectedItems(this.selectedRowKeys, (response) => {
        this.refreshGrid();
        this.alertService.success('PRODUCT_CATALOGUES.DELETE_SELECTED_ITEMS_SUCCESS');
      })
    });

    this.dialogService.show(dialog);
  }

  deactivateItems() {
    let dialogData = new Dialog('PRODUCT_CATALOGUE.DEACTIVATE_ITEMS_MESSAGE', () => {

      this.productCatalogueItemsService.deactivateItems(this.selectedRowKeys, (response) => {
        this.refreshGrid();
        this.alertService.success('PRODUCT_CATALOGUES.ITEMS_DEACTIVATED');

        // TODO: SELEKTUJ SVE ITEME OD PRIJE
      }), (error) => {
        this.alertService.error(error)
      }
    })
    this.dialogService.show(dialogData);

  }

  public openAddByAttributeModal() {
    this.isAddByAttributeModalVisible = true;
  }

  public openAddAllModal() {
    this.isAddAllModalVisible = true;
  }

  public openAddItemModal() {
    this.isAddItemModalVisible = true;
  }

  addItemAndContinue() {
    this.addItem(false);
  }

  refreshGrid(refresh: boolean = false) {
    this.getGridData(`productCatalogue${SearchOperations.SPLIT_JOIN_OPERATOR}id${SearchOperations.EQUALITY}${this.productCatalogue.id}`, true);
    if(refresh) {
      this.articlesGrid.instance.repaint();
      this.articlesGrid.instance.refresh();
    }
  }

  addItem(shouldCloseModal: boolean = true) {
    if (!this.isEdit)
      this.productCatalogueItemsService.addItem(this.productCatalogueItem, this.productCatalogue.id, (response) => {
        this.alertService.success('PRODUCT_CATALOGUES.ITEM_ADDED_SUCCESSFULLY');
        // this.changePendingStatus();
        this.closeAddItemModal(shouldCloseModal);
        this.refreshGrid();
      });
    else
      this.productCatalogueItemsService.editItem(this.productCatalogueItem, (response) => {
        this.alertService.success('PRODUCT_CATALOGUES.ITEM_UPDATED_SUCCESSFULLY');
        // this.changePendingStatus();
        this.closeAddItemModal(shouldCloseModal);
        this.refreshGrid();
      });
  }

  public attributeTypeChanged(event) {
    if (this.productAttributeType != event.value) {
      this.productAttributeType = event.value;
      this.productAttributes = [];
      this.productAttributesSource = this.productClassificationService.getAttributesByType(event.value);
    }
  }

  public closeAddByAttributeModal() {
    this.productAttributeType = null;
    this.productAttributes = [];
    this.amountFrom = 0;
    this.discountPercentage1 = 0;
    this.discountPercentage2 = 0;
    this.discountPercentage3 = 0;
    this.isAddByAttributeModalVisible = false;
    this.productAttributesSource = null;
  }

  public addByAttribute() {
    let data = new AttributeSelection();
    data.productCatalogue = this.productCatalogue.id;
    data.pointOfSale = this.pointOfSaleId;
    data.amountFrom = this.amountFrom;
    data.discountPercentage1 = this.discountPercentage1;
    data.discountPercentage2 = this.discountPercentage2;
    data.discountPercentage3 = this.discountPercentage3;
    data.productAttributeType = this.productAttributeType;
    data.updateExisting = this.updateProducts;
    data.productAttributes = [];
    for (let pa of this.productAttributes) {
      data.productAttributes.push(pa.id);
    }

    this.productCatalogueItemsService.addItemsByAttribute(data, (response) => {
      this.alertService.success('PRODUCT_CATALOGUES.ITEMS_ADDED_SUCCESSFULLY');
      this.closeAddByAttributeModal();
      this.refreshGrid();
    });
  }


  editItem(item: ProductCatalogueItem) {
    this.isEdit = true;
    this.addItemModalTitle = 'PRODUCT_CATALOGUES.EDIT_PRODUCT';
    this.productCatalogueItem = JSON.parse(JSON.stringify(item));
    this.productCatalogueItem.discountPrice1 = this.calculateDiscount1(this.productCatalogueItem);
    this.productCatalogueItem.discountPrice2 = this.calculateDiscount2(this.productCatalogueItem);
    this.productCatalogueItem.discountPrice3 = this.calculateDiscount3(this.productCatalogueItem);
    this.openAddItemModal();
  }


  deleteItem(id: string) {
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
      this.productCatalogueItemsService.deleteItem(id, (response) => {
        this.alertService.success('PRODUCT_CATALOGUES.ITEM_DELETED_SUCCESSFULLY');
        // this.changePendingStatus();
        this.closeAddItemModal();
        this.refreshGrid();
      })
    });

    this.dialogService.show(dialog);
  }

  calculateDiscountPrice(discountNumber: number) {
    if (this.productCatalogueItem) {
      let discountPrice: number | string;
      let discountPercentage: number;

      switch (discountNumber) {
        case 1:
          discountPrice = this.productCatalogueItem.discountPrice1;
          discountPercentage = this.productCatalogueItem.discountPercentage1;
          break;
        case 2:
          discountPrice = this.productCatalogueItem.discountPrice2;
          discountPercentage = this.productCatalogueItem.discountPercentage2;
          break;
        case 3:
          discountPrice = this.productCatalogueItem.discountPrice3;
          discountPercentage = this.productCatalogueItem.discountPercentage3;
          break;
      }

      if (discountPercentage) {
        discountPrice = Number(ProductCatalogueItemsComponent.roundUp(((<OfferedProduct>this.productCatalogueItem.offeredProduct).regularPrice - (<OfferedProduct>this.productCatalogueItem.offeredProduct).regularPrice * discountPercentage / 100)).toFixed(2));
      }

      switch (discountNumber) {
        case 1:
          this.productCatalogueItem.discountPrice1 = discountPrice;
          this.productCatalogueItem.discountPercentage1 = discountPercentage;
          break;
        case 2:
          this.productCatalogueItem.discountPrice2 = discountPrice;
          this.productCatalogueItem.discountPercentage2 = discountPercentage;
          break;
        case 3:
          this.productCatalogueItem.discountPrice3 = discountPrice;
          this.productCatalogueItem.discountPercentage3 = discountPercentage;
          break;
      }
    }
  }

  calculateDiscountPercentage(discountNumber: number) {
    if (this.productCatalogueItem) {
      let discountPrice: number | string;
      let discountPercentage: number;

      switch (discountNumber) {
        case 1:
          discountPrice = this.productCatalogueItem.discountPrice1;
          discountPercentage = this.productCatalogueItem.discountPercentage1;
          break;
        case 2:
          discountPrice = this.productCatalogueItem.discountPrice2;
          discountPercentage = this.productCatalogueItem.discountPercentage2;
          break;
        case 3:
          discountPrice = this.productCatalogueItem.discountPrice3;
          discountPercentage = this.productCatalogueItem.discountPercentage3;
          break;
      }

      if (discountPrice) {
        let regularPrice = (<OfferedProduct>this.productCatalogueItem.offeredProduct).regularPrice;
        discountPercentage = Number(ProductCatalogueItemsComponent.reCalculateDiscount(regularPrice, <number>discountPrice));
      }

      switch (discountNumber) {
        case 1:
          this.productCatalogueItem.discountPrice1 = discountPrice;
          this.productCatalogueItem.discountPercentage1 = discountPercentage;
          break;
        case 2:
          this.productCatalogueItem.discountPrice2 = discountPrice;
          this.productCatalogueItem.discountPercentage2 = discountPercentage;
          break;
        case 3:
          this.productCatalogueItem.discountPrice3 = discountPrice;
          this.productCatalogueItem.discountPercentage3 = discountPercentage;
          break;
      }
    }
  }

  onDiscountPercentage1Changed = (event) => {
    if (event.value != event.previousValue)
      this.calculateDiscountPrice(1);
  }
  onDiscountPercentage2Changed = (event) => {
    if (event.value != event.previousValue)
      this.calculateDiscountPrice(2);
  }
  onDiscountPercentage3Changed = (event) => {
    if (event.value != event.previousValue)
      this.calculateDiscountPrice(3);
  }

  onDiscountPrice1Changed = (event) => {
    if (event.value != event.previousValue)
      this.calculateDiscountPercentage(1);
  }
  onDiscountPrice2Changed = (event) => {
    if (event.value != event.previousValue)
      this.calculateDiscountPercentage(2);
  }
  onDiscountPrice3Changed = (event) => {
    if (event.value != event.previousValue)
      this.calculateDiscountPercentage(3);
  }

  // can it be solved with 1 function?
  calculateDiscount1(rowData) {
    let discountPrice1: number = 0;
    if (rowData.discountPercentage1 != null) {
      discountPrice1 = ProductCatalogueItemsComponent.roundUp(Number((rowData.offeredProduct.regularPrice - (rowData.offeredProduct.regularPrice * rowData.discountPercentage1) / 100).toFixed(2)));
      rowData.discountPrice1 = discountPrice1;
      return discountPrice1;
    }
    else return "";
  }
  calculateDiscount2 = (rowData) => {
    let discountPrice2 = 0;
    if (rowData.discountPercentage2 != null) {
      discountPrice2 = Number((rowData.offeredProduct.regularPrice - (rowData.offeredProduct.regularPrice * rowData.discountPercentage2) / 100).toFixed(2))
      if (this.pointOfSaleType === "WHOLESALE")
        return discountPrice2
      else
        return ProductCatalogueItemsComponent.roundUp(discountPrice2);
    }
    else return "";
  }
  calculateDiscount3(rowData) {
    let discountPrice3: number = 0;
    if (rowData.discountPercentage3 != null) {
      discountPrice3 = ProductCatalogueItemsComponent.roundUp(Number((rowData.offeredProduct.regularPrice - (rowData.offeredProduct.regularPrice * rowData.discountPercentage3) / 100).toFixed(2)));
      return discountPrice3;
    }
    else return "";
  }


  offeredProductChanged = (event) => {
    // this.productCatalogueItem.offeredProduct = event.selectedItem;
    this.recalculateAllDiscountPrices();
  }

  recalculateAllDiscountPrices() {
    this.calculateDiscountPercentage(1);
    this.calculateDiscountPercentage(2);
    this.calculateDiscountPercentage(3);
  }

  public closeAddAllModal() {
    this.isAddAllModalVisible = false;
  }

  public closeAddItemModal(shouldCloseModal: boolean = true) {
    this.productCatalogueItem = new ProductCatalogueItem();
    this.productCatalogueItem.amountFrom = 1;
    this.productCatalogueItem = new ProductCatalogueItem();
    this.isEdit = false;
    this.addItemModalTitle = 'REBATE_POLICIES.ADD_PRODUCT';
    this.isAddItemModalVisible = !shouldCloseModal;
    
    this.articlesGrid.instance.repaint();
    this.articlesGrid.instance.refresh();
  }

  onContentReady(e) {
    if (!this.isEdit) {
      let editor = e.component.getEditor("offeredProduct");

      if (editor !== undefined) {
        setTimeout(() => {
          editor.focus();
          editor.open();
        }, 500);
      }
    }
  }

  private static roundUp(price: number): number {
    let secondDigit = Math.round(price * 100 % 10);

    if (secondDigit >= 8)
      return price = Number((price + ((10 - secondDigit) * 0.01)).toFixed(2))
    else if (secondDigit >= 3 && secondDigit <= 7)
      return price = Number((price - ((secondDigit * 0.01) - 0.05)).toFixed(2))
    else return price = Number((price - (secondDigit * 0.01)).toFixed(2))
  }

  private static reCalculateDiscount(regularPrice: number, discountPrice: number): number {
    return (regularPrice - discountPrice) / regularPrice * 100;
  }


  onSelectionChanged(e) {
    if (this.deactivateItemsButtonInstance != null)
      this.deactivateItemsButtonInstance.option('disabled', this.selectedRowKeys.length == 0);
    this.selectionChangedEvent.emit(this.selectedRowKeys)
  }


  public onRowUpdated(event) {
    if (event.newData.discountPrice1 != null)
      event.oldData.discountPercentage1 = ProductCatalogueItemsComponent.reCalculateDiscount(event.oldData.offeredProduct.regularPrice, event.newData.discountPrice1);
    if (event.newData.discountPrice2 != null)
      event.oldData.discountPercentage2 = ProductCatalogueItemsComponent.reCalculateDiscount(event.oldData.offeredProduct.regularPrice, event.newData.discountPrice2);
    if (event.newData.discountPrice3 != null)
      event.oldData.discountPercentage3 = ProductCatalogueItemsComponent.reCalculateDiscount(event.oldData.offeredProduct.regularPrice, event.newData.discountPrice3);
  }



  onAttributeSelectionChanged(event) {
    this.productAttributes = event;
  }

  getAttributesUrl() {
    let url = null;
    switch (this.productAttributeType) {
      case 'ASSORTMENT': url = `${Constants.contextPath}/product-assortments`; break;
      case 'BRAND': url = `${Constants.contextPath}/product-brands`; break;
      case 'CATEGORY': url = `${Constants.contextPath}/product-categories`; break;
      case 'GROUP': url = `${Constants.contextPath}/product-groups`; break;
      case 'MERCHANDISE_GROUP': url = `${Constants.contextPath}/product-merchandise-groups`; break;
      default: url = null;
    }
    return url;
  }
}
